module.exports = __webpack_public_path__ + "img/barricas_1.906ee535.jpeg";